<template>
  <header>
    <div class="container header-container">
      <div v-if="!isShop" class="back-button" @click="back"></div>

      <div
        v-else-if="routerName != 'shopPreCatalog'"
        class="back-to-catalog"
        @click="goToMainCatalog()"
      >
        В каталог
      </div>

      <div v-if="isControl" class="burger" @click="controllExit()">
        <span></span>
        <span></span>
        <span></span>
      </div>

      <div v-else-if="!isShop" class="burger" @click="goToMain()">
        <span></span>
        <span></span>
        <span></span>
      </div>

      <div v-else class="shop-exit" @click="shopExit()">Выйти из магазина</div>

      <div class="user" @click="$router.push({ name: 'userPage' })">
        <img :src="user.userAvatar" alt="" />
      </div>
    </div>
  </header>
</template>
<script>
export default {
  props: ["routerName"],
  data: () => ({
    user: "",
    isShop: false,
    isControl: false,
  }),
  methods: {
    back() {
      if (this.routerName == "mainPage") {
        //Отключить кнопку "назад" на главной
        return false;
      } else if (this.routerName == "replacement") {
        //Отключить кнопку "назад" на странице "работа по замене"
        this.$makeToast(
          "Упс!",
          "danger",
          "Вы не можете покинуть страницу пока не завершите работу по замене",
          50000
        );
      } else {
        this.$router.go(-1);
      }
    },
    goToMain() {
      if (this.routerName == "mainPage") {
        //Отключить бургер на главной
        return false;
      } else if (this.routerName == "replacement") {
        //Отключить бургер на странице "работа по замене"
        this.$makeToast(
          "Упс!",
          "danger",
          "Вы не можете покинуть страницу пока не завершите работу по замене",
          50000
        );
      } else {
        this.$router.push({ name: "mainPage" });
      }
    },
    goToMainCatalog() {
      this.$router.push("/shop-pre-catatlog");
    },
    isShopPage() {
      let routes = [
        "shopPreCatalog",
        "shopCatalog",
        "shopCatalog-child",
        "catalog-shop",
        "shop-product-card",
        "shopCart",
      ];
      for (var i in routes) {
        if (routes[i] == this.routerName) {
          this.isShop = true;
          return false;
        } else {
          this.isShop = false;
        }
      }
    },
    isControlPage() {
      let routes = ["contolCatalog", "controlDetail", "manufactureOrder"];
      for (var i in routes) {
        if (routes[i] == this.routerName) {
          this.isControl = true;
          return false;
        } else {
          this.isControl = false;
        }
      }
    },
    leaveShop() {
      this.$localStorageSet("miniCart", {});
      this.$router.push({ name: "mainPage" });
      this.$bvToast.hide();
    },
    leaveControlPage() {
      this.$localStorageSet("miniCart", {});
      this.$localStorageDelete("currentControlID");
      this.$localStorageDelete("currentClient");
      this.$localStorageDelete("currentCollection");
      this.$router.push({ name: "mainPage" });
      this.$bvToast.hide();
    },

    shopExit() {
      let link1 = this.$createElement(
        "p",
        {
          attrs: {
            class: "leaveShop",
          },
          on: { click: () => this.leaveShop() },
        },
        "Выйти"
      );

      let link2 = this.$createElement(
        "p",
        {
          attrs: {
            class: "close-modal",
          },
          on: { click: () => this.$bvToast.hide() },
        },
        "Остаться"
      );

      let buttonsBlock = this.$createElement(
        "div",
        {
          class: "buttons-block",
        },
        [
          "После выхода из магазина корзина будет очищена, желаете продолжить?",
          link1,
          link2,
        ]
      );

      this.$bvToast.toast([buttonsBlock], {
        title: "Внимание!!!",
        autoHideDelay: 50000,
        variant: "danger",
        toaster: "b-toaster-top-center",
        appendToast: true,
        noAutoHide: true,
        noCloseButton: true,
      });
    },

    controllExit() {
      let link1 = this.$createElement(
        "p",
        {
          attrs: {
            class: "leaveShop",
          },
          on: { click: () => this.leaveControlPage() },
        },
        "Выйти"
      );

      let link2 = this.$createElement(
        "p",
        {
          attrs: {
            class: "close-modal",
          },
          on: { click: () => this.$bvToast.hide() },
        },
        "Остаться"
      );

      let buttonsBlock = this.$createElement(
        "div",
        {
          class: "buttons-block",
        },
        [
          "После выхода в гавное меню, все изменения будут утеряны желаете продолжить?",
          link1,
          link2,
        ]
      );

      this.$bvToast.toast([buttonsBlock], {
        title: "Внимание!!!",
        autoHideDelay: 50000,
        variant: "danger",
        toaster: "b-toaster-top-center",
        appendToast: true,
        noAutoHide: true,
        noCloseButton: true,
      });
    },
  },
  created() {
    // При перезагрузке страницы очищается state
    this.user = JSON.parse(localStorage.getItem("userInfo"));
    if (!this.$store.getters.GET_USER_INFO.userID) {
      this.$store.dispatch("SET_USERINFO_FROM_LOCAL_STORAGE", this.user);
    }

    this.isShopPage();
    this.isControlPage();
  },
  watch: {
    routerName(newVal, oldVal) {
      this.isShopPage();
      this.isControlPage();
    },
  },
};
</script>
<style lang="scss" scoped>
.background-block,
.shadow-block {
  min-height: 100%;
  width: 100%;
}
.shadow-block {
  padding-bottom: 60px;
  width: 100%;
}
.burger {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 0;
  &.disabled {
    pointer-events: none;
  }
}
.back-button {
  &.disabled {
    pointer-events: none;
  }
}
.back-to-catalog {
  width: 75px;
  font-size: 12px;
  font-weight: bold;
  border-radius: 7px;
  height: 25px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #279b37;
  color: #fff;
}
.shop-exit {
  width: 130px;
  font-size: 12px;
  font-weight: bold;
  border-radius: 7px;
  height: 25px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ce181e;
  color: #fff;
}
.header-container {
  justify-content: space-between;
}
.leaveShop {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ce181e;
  width: 100px;
  height: 30px;
  border-radius: 5px;
  color: #fff;
  margin-top: 20px;
}
.close-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #279b37;
  width: 100px;
  height: 30px;
  border-radius: 5px;
  color: #fff;
  margin-top: 20px;
  margin-left: 30px;
}
.buttons-block {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
  padding-bottom: 15px;
}
</style>